module.exports = __webpack_public_path__ + "media/images/ic_petit_dejeuner-7c810a352ea7da172d9d9a39c051ec32.svg";